import script from "./titleHeader1.vue?vue&type=script&setup=true&lang=js"
export * from "./titleHeader1.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__